var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 8"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M.328 1.216a.59.59 0 0 1 0-.825.564.564 0 0 1 .797-.011l.01.01L7.01 6.372l5.855-5.97a.564.564 0 0 1 .798-.01l.01.01c.22.225.224.586.01.815l-.01.01-6.26 6.382a.564.564 0 0 1-.796.011l-.011-.01z"
  })));
};
export default SvgChevronDown;